$sbbTableTbodyPadding: 1rem; // 16px
$sbbTableCellPaddingVertical: 0.375rem; // 6px
$sbbTableFontSize: 1rem;
$sbbTableLineHeightMedium: 1.25rem; // 20px

.sbbSortHeaderContainer {
  display: flex !important;
  text-align: center !important;
  height: 25px;
  align-items: center;
}

.columnTitle {
  text-align: left;
  width: 100%;
}

.sortArrow {
  text-align: right;
}

.filterIcon {
  margin-top: -10px;
  margin-left: -5px;
  margin-right: -10px;
  text-align: right;
}

.filter {
  margin-top: -7px;
  margin-right: 5px;
  cursor: pointer;
}
.filter {
  margin-top: -6px;
  margin-right: 5px;
  cursor: pointer;
}
.filter_x {
  margin-right: 5px;
}

.filter_settings {
  margin-right: 5px;
  cursor: pointer;
}

.table {
  border-spacing: 0;
  width: 100%;
  //font-size: $sbbTableFontSize;
  //line-height: $sbbTableLineHeightMedium;
  //padding-bottom: $sbbTableTbodyPadding;
  //padding-bottom: 0;

  tr:nth-child(even) {
    background-color: #fcfcfc;
  }

  > * > tr > td,
  > * > tr > th {
    position: relative;
  }

  > thead > tr {
    &:last-child {
      > :is(th, td) {
        border-bottom: 1px solid var(--sbb-color-graphite);
      }
    }

    > :is(th, td) {
      text-align: start;
      padding: $sbbTableCellPaddingVertical $sbbTableTbodyPadding;

      &:first-child {
        //padding-left: 0;
      }

      &:last-child {
        border-right: none;
      }
    }
  }

  > tbody > tr {
    // border-right: 20px solid var(--sbb-color-white);
    // border-left: 20px solid var(--sbb-color-white);

    &:is(:hover, :focus, :focus-within) > :is(td, th) {
      text-align: start;
      background-color: var(--sbb-color-milk);
      border-bottom: 1px solid var(--sbb-color-red125);
    }

    > :is(td, th) {
      vertical-align: middle;
      border-bottom: 1px solid var(--sbb-color-milk);
      cursor: default;
      border-right: 1px solid var(--sbb-color-white);
      padding: $sbbTableCellPaddingVertical $sbbTableTbodyPadding;

      &:first-child {
        //padding-left: 0;
      }

      &:last-child {
        border-right: none;
        //padding-right: 0;
      }
    }

    &:last-child > :is(td, th) {
      border-bottom: none;
    }
  }

  &.noHorizontalSeparation {
    > tbody > tr {
      :is(td, th) {
        border-bottom: none;
        padding-top: calc($sbbTableCellPaddingVertical / 2);
        padding-bottom: calc($sbbTableCellPaddingVertical / 2);
      }
    }
  }

  &.noVerticalSeparation {
    > tbody > tr {
      :is(td, th) {
        border-right: none;
        padding-left: calc($sbbTableTbodyPadding / 2);
        padding-right: calc($sbbTableTbodyPadding / 2);

        &:first-child {
          //padding-left: 0;
        }

        &:last-child {
          //padding-right: 0;
        }
      }
    }
  }
}
